import { BaseEntity } from "yt-ng-framework";
import { EOtpremnicaStavka } from "../eotpremnica/eotpremnica-stavka";

export class EPrijemnicaStavka extends EOtpremnicaStavka{
    constructor(){
        super();
    }   
    PristiglaKolicina: number = null;
    PrimljenaKolicina: number = null;
    VracenaKolicina: number = null;
    EPrijemnicaID: number = null;
    EOtpremnicaDokumentStavkeID:  number = null;

    Deserialize(input:any){  
        super.Deserialize(input);
        this.ID=input.ID;
        this.PristiglaKolicina=input.PristiglaKolicina;
        this.PrimljenaKolicina=input.PrimljenaKolicina;
        this.VracenaKolicina=input.PristiglaKolicina-input.PrimljenaKolicina;
        this.EPrijemnicaID = input.EPrijemnicaID;
        this.EOtpremnicaDokumentStavkeID = input.EOtpremnicaDokumentStavkeID;
        return this;
    }

    Serialize(input:EPrijemnicaStavka){
        return input;
    }
}